import { render, staticRenderFns } from "./AbkTimeline.vue?vue&type=template&id=022df8fd&scoped=true&"
import script from "./AbkTimeline.vue?vue&type=script&lang=js&"
export * from "./AbkTimeline.vue?vue&type=script&lang=js&"
import style0 from "./AbkTimeline.vue?vue&type=style&index=0&id=022df8fd&scoped=true&lang=scss&"
import style1 from "./AbkTimeline.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022df8fd",
  null
  
)

export default component.exports